<ng-container [formGroup]="formGroup">
    <!-- #region insurant title & name -->
    @if (formGroup.get('isInsuree').value !== true) {
        @if (askForTitle) {
            <div class="grid-container">
                <div class="g-12 form-control">
                    <label
                        appReactiveLabel
                        formControlName="title"
                        [for]="'title-' + id"
                        >{{ 'Anrede' | formLabel: true : 'select' }}</label
                    >
                    <app-title-selector
                        formControlName="title"
                        [id]="'title-' + id"
                        [ctrlErrorMessage]="titleErrorMessage"
                    ></app-title-selector>
                </div>
            </div>
        }
        <div class="grid-container">
            <div class="g-12 form-control">
                <label
                    [for]="'first-name-' + id"
                    appReactiveLabel
                    formControlName="firstName"
                    >{{ 'Vorname' | formLabel }}:</label
                >
                <input
                    [id]="'first-name-' + id"
                    type="text"
                    formControlName="firstName"
                    [placeholder]="'Vorname' | formLabel"
                    [ctrlErrorMessage]="firstNameErrorMessage"
                    required
                />
            </div>
        </div>
        <div class="grid-container">
            <div class="g-12 form-control">
                <label
                    [for]="'last-name-' + id"
                    appReactiveLabel
                    formControlName="lastName"
                    >{{ 'Nachname' | formLabel }}:</label
                >
                <input
                    [id]="'last-name-' + id"
                    type="text"
                    formControlName="lastName"
                    [placeholder]="'Nachname' | formLabel"
                    [ctrlErrorMessage]="lastNameErrorMessage"
                    required
                />
            </div>
        </div>
    }
    <!-- #endregion -->

    <!-- #region date of birth form control -->
    @if (!formGroup.get('isInsuree').value || !auth.isLoggedIn) {
        <div class="grid-container">
            <div class="g-12 form-control">
                <label
                    [for]="'date-of-birth-' + id"
                    formControlName="dateOfBirth"
                    appReactiveLabel
                    >{{ 'Geburtsdatum' | formLabel: true : 'date' }}:</label
                >
                <input
                    [id]="'date-of-birth-' + id"
                    ctrlDateInput
                    type="text"
                    [placeholder]="'Geburtsdatum' | formLabel: true : 'date'"
                    formControlName="dateOfBirth"
                    [ctrlErrorMessage]="dateErrorMessages()"
                    required
                />
            </div>
        </div>
    } @else {
        <div class="grid-container m-12:b md:m-16:b lg:m-24:b">
            <div class="g-6">
                <label class="-display">{{ 'Geburtsdatum' }}:</label>
            </div>
            <div class="g-6">
                <p class="align:r fit-label">
                    <strong>
                        {{ formGroup.get('dateOfBirth').value }}
                    </strong>
                </p>
            </div>
        </div>
    }
    <!-- #endregion -->

    <!-- #region date of birth display only -->
    <!-- #endregion -->

    <!-- #region insurance ranks -->
    @if (insuranceRanks && insuranceRanks.length) {
        <div class="grid-container">
            <div class="g-12 form-control">
                <label
                    [for]="'insurance-rank-' + id"
                    formControlName="insuranceRankId"
                    appReactiveLabel
                    >Tarif*:</label
                >
                <div>
                    <select
                        [id]="'insurance-rank-' + id"
                        formControlName="insuranceRankId"
                        [required]="ranksMandatory"
                    >
                        <option
                            [value]="null"
                            disabled
                        >
                            {{ 'Tarif' | formLabel: true : 'select' }}
                        </option>
                        @for (insuranceRank of insuranceRanks; track insuranceRank) {
                            <option [ngValue]="insuranceRank.id">
                                {{ insuranceRank.description }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        </div>
    }
    <!-- #endregion -->
    <!-- #region missing teeth -->
    @if (askForMissingTeeth) {
        <div class="grid-container">
            <div
                class="g-12 form-control"
                [ngClass]="{ 'with-info-tooltip': usageNotes?.missingTeeth }"
            >
                <label
                    [for]="'missing-teeth-' + id"
                    formControlName="missingTeeth"
                    appReactiveLabel
                    >{{ 'Fehlende Zähne' | formLabel }}:</label
                >
                <select
                    [id]="'missing-teeth-' + id"
                    [required]="true"
                    formControlName="missingTeeth"
                    [ctrlErrorMessage]="missingTeethErrorMessages"
                >
                    <option
                        [value]="null"
                        disabled
                    >
                        {{ 'Fehlende Zähne' | formLabel: true : 'select' }}
                    </option>
                    @for (missingTeeth of ['keine', '1', '2', '3', '4 oder mehr']; track $index) {
                        <option [ngValue]="$index">
                            {{ missingTeeth }}
                        </option>
                    }
                </select>
                @if (usageNotes?.missingTeeth) {
                    <app-info-tooltip [text]="usageNotes?.missingTeeth"></app-info-tooltip>
                }
            </div>
        </div>
    }
    <!-- #endregion -->
    <!-- #region health insurance -->
    @if (askForHealthInsurance && gkvNames$ | async) {
        <div class="grid-container">
            <div class="g-12 form-control">
                <app-autocomplete-with-fallback-input
                    [id]="'health-insurance' + id"
                    formControlName="healthInsurance"
                    placeholder="Gesetzliche Krankenversicherung"
                    optionsLabel="Gesetzliche Krankenversicherung*:"
                    fallbackOptionLabel="Bitte gib eine Krankenversicherung an"
                    [options]="gkvNames$ | async"
                    [maxLength]="70"
                    [ctrlErrorMessage]="healthInsuranceErrorMessages"
                ></app-autocomplete-with-fallback-input>
                @if (hasSelectedOtherOption) {
                    <p class="m-36:t">
                        <strong>Hinweis:</strong> Ein Abschluss ist nur möglich, wenn Du in der gesetzlichen
                        Krankenversicherung versichert bist. Für Mitglieder einer privaten Krankenversicherung oder der
                        Heilfürsorge besteht kein Versicherungsschutz.
                    </p>
                }
            </div>
        </div>
    }
    <!-- #endregion -->
</ng-container>
